module.exports = __webpack_public_path__ + "static/media/panorama.9e488a8f.png";